import { AddressDetailsModel } from './client.model';

export class ClientListRequestModel {
  sort_direction: 'asc' | 'desc' = 'asc';
  sort_field: 'firstName' | 'lastName' | 'email' | 'registered' = 'firstName';
  query: string;
  filter_mvp_connected: boolean;
  filter_consent_accepted: boolean;
  exclude_placeholder_emails: boolean = false;
  filter_mandate_state: 'NO_SIGNATURE' | 'PENDING' | 'APPROVED' | 'POOL_MANDATE_SIGNED';
  filter_main_advisor: string;
  filter_analysis?: string;
  filter_potential?: string;
  filter_financial_profile_completed?: boolean;
  /** 'Handlungsbedarf' chip (FIN-7177): resolved to filter_client_ids from the banking events before the request */
  filter_events?: boolean;
  filter_client_ids?: string;
  page: number = 0;
  page_size: number = 25;
}

export class CreateClientRequestModel {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  birthDate: string;
  taxId: string;
  email: string;
  mainAdvisorId: string;
  address: AddressDetailsModel;
}

export class UpdateClientDetailsRequestModel {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  birthDate: string;
  taxId: string;
  address: AddressDetailsModel;
}
